<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    :overlay="false"
    min-width="500px"
  >
    <v-card>
      <v-toolbar dark color="#E3002C" class="d-flex align-center">
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-toolbar>
            <v-text-field
              hide-details
              label="Cultivo"
              id="cultivo"
              v-model="this.crop.description"
              disabled
            />
            <v-spacer></v-spacer>
            <v-autocomplete
              v-if="this.orderDocument.inventory_has_client"
              :disabled="this.clientItems && this.clientItems.length == 1"
              label="Cliente"
              :items="clientItems"
              hide-details
              hide-no-data
              hide-selected
              item-text="name"
              item-value="url"
              v-model="selectedClient"
              return-object
              @change="clientSelected($event)"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-autocomplete
              label="Producto"
              :items="productItems"
              :search-input.sync="inventorySearchProduct"
              :loading="inventoryLoadingProduct"
              hide-details
              hide-no-data
              hide-selected
              :item-text="getProductText"
              item-value="url"
              v-model="selectedProduct"
              return-object
              @change="productSelected($event)"
              ref="productAutocomplete"
              prepend-icon="mdi-close"
              @click:prepend="clearAutocomplete('productAutocomplete')"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-autocomplete
              label="Banda"
              :items="bandItems"
              hide-details
              hide-no-data
              hide-selected
              item-text="description"
              item-value="url"
              return-object
              @change="bandSelected($event)"
              ref="bandAutocomplete"
              prepend-icon="mdi-close"
              @click:prepend="clearAutocomplete('bandAutocomplete')"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-autocomplete
              label="Calibre"
              :items="gaugeItems"
              hide-details
              hide-no-data
              hide-selected
              item-text="description"
              item-value="url"
              v-model="selectedGauge"
              return-object
              @change="gaugeSelected($event)"
              ref="gaugeAutocomplete"
              prepend-icon="mdi-close"
              @click:prepend="clearAutocomplete('gaugeAutocomplete')"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-autocomplete
              label="Curado"
              :items="curingItems"
              hide-details
              hide-no-data
              hide-selected
              item-text="description"
              item-value="url"
              v-model="selectedCuring"
              return-object
              @change="curingSelected($event)"
              ref="curingAutocomplete"
              prepend-icon="mdi-close"
              @click:prepend="clearAutocomplete('curingAutocomplete')"
            ></v-autocomplete>
          </v-toolbar>
        </v-card>
        <v-card>
          <v-data-table
            dense
            v-bind:page="page"
            :pageCount="this.pageCount"
            :loading="loading"
            :headers="headers"
            :items="items"
            :itemsPerPage="itemsPerPage"
            :serverItemsLength="serverItemsLength"
            :options.sync="options"
            @click:row="onClickRow"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "InventorySearchDialog",

  props: {
    show: {
      type: Boolean,
      default: false
    },
    product: {
      type: String,
      default: null
    },
    gauge: {
      type: String,
      default: null
    },
    curing: {
      type: String,
      default: null
    },
    crop: {
      type: Object,
      default: null
    },
    campaign: {
      type: Object,
      default: null
    },
    clientItems: {
      type: Array,
      default: null
    },
    orderDocument: {
      type: Object,
      default: null
    },
    order_id: {
      type: Number,
      default: 0
    },
    only_positives: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      title: "Búsqueda de Inventario",
      endpoint: "/data/inventories_search",
      loading: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 100,
      options: {},
      headers: [
        { text: "Codigo", value: "product_code", sortable: false },
        { text: "Producto", value: "product_description", sortable: false },
        { text: "Banda", value: "band_description", sorteable: false },
        { text: "Calibre", value: "gauge_description", sortable: false },
        { text: "Curado", value: "curing_description", sortable: false },
        { text: "Tipo", value: "sector_description", sorteable: false },
        {
          text: "Inventario Disponible",
          value: "available_amount",
          sorteable: true,
          align: "end"
        }
      ],
      items: [],
      productItems: [],
      gaugeItems: [],
      curingItems: [],
      bandItems: [],
      filterGauge: null,
      filterCuring: null,
      filterProduct: null,
      filterBand: null,
      filterClient: null,
      selectedProduct: null,
      selectedGauge: null,
      selectedCuring: null,
      selectedClient: null,
      inventoryLoadingProduct: false,
      inventorySearchProduct: null,
      mounting: true,
      defaultProduct: null
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    inventorySearchProduct: {
      handler(val) {
        this.inventoryDoIntelliSearch("product", val);
      }
    },
    options: {
      handler() {
        this.inventoryReadDataFromAPI(false);
      }
    },
    deep: true
  },

  methods: {
    onClose() {
      this.$emit("cancel");
    },
    onClickRow(item) {
      this.$emit("itemSelected", item);
    },

    productSelected(item) {
      this.filterProduct = item;
      this.inventoryReadDataFromAPI(true);
    },

    clientSelected(item) {
      this.filterClient = item;
      this.inventoryReadDataFromAPI(true);
    },

    gaugeSelected(item) {
      this.filterGauge = item;
      this.inventoryReadDataFromAPI(true);
    },

    curingSelected(item) {
      this.filterCuring = item;
      this.inventoryReadDataFromAPI(true);
    },

    bandSelected(item) {
      this.filterBand = item;
      this.inventoryReadDataFromAPI(true);
    },

    inventoryDoIntelliSearch(field, val) {
      switch (field) {
        case "product":
          this.loadProducts(val);
          break;
      }
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "gaugeAutocomplete":
          this.filterGauge = null;
          break;
        case "curingAutocomplete":
          this.filterCuring = null;
          break;
        case "productAutocomplete":
          this.filterProduct = null;
          break;
        case "bandAutocomplete":
          this.filterBand = null;
          break;
      }
      this.inventoryReadDataFromAPI(true);
    },

    async loadGauges() {
      this.filterGauge = null;
      this.gaugeItems = [];

      let filterString = this.crop ? "crop__id=" + this.crop.id.toString() : "";

      let gauges = await this.$bRoot.search(
        "/data/gauges",
        null,
        "description",
        filterString
      );

      this.gaugeItems = gauges.data.results;

      //set defaults
      if (this.mounting && this.gauge) {
        let index = this.gaugeItems.findIndex(item => item.url === this.gauge);
        if (index !== -1) {
          this.selectedGauge = this.gaugeItems[index].url;
          this.filterGauge = this.gaugeItems[index];
        }
      }
    },

    async loadBands() {
      this.filterBand = null;
      this.bandItems = [];

      let bands = await this.$bRoot.search(
        "/data/bands",
        null,
        "description",
        null
      );

      this.bandItems = bands.data.results;
    },

    async loadProducts(searchString) {
      if (this.filterProduct) {
        if (this.getProductText(this.filterProduct) === searchString) return;
      }
      this.inventoryLoadingProduct = true;
      try {
        this.filterProduct = null;
        this.productsItems = [];

        let filterString = this.crop
          ? "crop__id=" + this.crop.id.toString()
          : "";

        let products = await this.$bRoot.searchAll(
          "/data/products",
          searchString,
          "description",
          filterString
        );

        this.productItems = products;

        //set default
        if (this.mounting && this.product) {
          //eslint-disable-next-line
          let index = this.productItems.findIndex(item => item.url === this.product);
          if (index !== -1) {
            this.selectedProduct = this.productItems[index].url;
            this.filterProduct = this.productItems[index];
          }
        } else {
          this.selectedProduct = null;
          this.filterProduct = null;
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.inventoryLoadingProduct = false;
      }
    },

    getProductText(item) {
      return item.code + " - " + item.description;
    },

    //Reading data from API method.
    async inventoryReadDataFromAPI(reset) {
      try {
        if (!this.mounting) {
          const { page, itemsPerPage } = this.options;
          let pageNumber = reset ? 1 : page;
          let endpoint =
            this.endpoint +
            "/" +
            (this.campaign && this.orderDocument.inventory_has_client === false ? this.campaign.id.toString() : "0") + // eslint-disable-line
            "/" +
            (this.crop ? this.crop.id.toString() : "0") +
            "/" +
            (this.filterProduct ? this.filterProduct.id.toString() : "0") +
            "/" +
            (this.filterGauge ? this.filterGauge.id.toString() : "0") +
            "/" +
            (this.filterCuring ? this.filterCuring.id.toString() : "0") +
            "/" +
            (this.filterBand ? this.filterBand.id.toString() : "0") +
            "/" +
            (this.filterClient && this.orderDocument.inventory_has_client ? this.filterClient.id.toString() : "0") + // eslint-disable-line
            "/" +
            this.orderDocument.id.toString() +
            "/" +
            (this.order_id ? this.order_id.toString() : "0") +
            "/" +
            this.only_positives.toString();

          let res = await this.$bRoot.search(
            endpoint,
            null,
            null,
            null,
            pageNumber
          );
          if (this.$bRoot.errors) {
            throw "Error recuperando datos";
          }
          if (res) {
            this.items = res.data.results;
            this.serverItemsLength = res.data.count;
            this.page = pageNumber;
            this.pageCount = Math.ceil(res.data.count / itemsPerPage);
          }
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = this.mounting;
      }
    }
  },

  async mounted() {
    this.current_level = this.$bRoot.auth.current_level;
    let curings = null,
      index = -1;

    try {
      //load default product
      if (this.product) {
        let response = await this.$bRoot.getObjectByURL(this.product);
        this.defaultProduct = response;
      }

      //load products
      await this.loadProducts();

      //load curings
      curings = await this.$bRoot.search("/data/curings", null, "description");
      this.curingItems = curings.data.results;
      //set default
      if (this.curing) {
        index = this.curingItems.findIndex(item => item.url === this.curing);
        if (index !== -1) {
          this.selectedCuring = this.curingItems[index].url;
          this.filterCuring = this.curingItems[index];
        }
      }

      //load gauges
      await this.loadGauges();

      //load bands
      await this.loadBands();

      //set Default Client
      if (
        this.orderDocument.inventory_has_client === true &&
        this.clientItems &&
        this.clientItems.length >= 1
      ) {
        this.filterClient = this.clientItems[0];
        this.selectedClient = this.filterClient.url;
      }

      //load data
      this.mounting = false;
      await this.inventoryReadDataFromAPI(true);
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.mounting = false;
    }
  }
};
</script>
<style scoped>
.v-data-table {
  margin-top: 0px;
}
</style>
